module.exports = __webpack_public_path__ + "media/store/fonts/LaplaceMonoWeb-Regular-7ecd11c755ee4092aa4f7e4ac68c2967.woff";